import React, { useEffect } from 'react';
import FetchButton from '../components/FetchButton';
import ProjectList from '../components/ProjectList';
import { useFreelancerAPI } from '../hooks/useFreelancerAPI';
import { useMyBids } from '../hooks/useMyBids';
import { useNavigate } from 'react-router-dom';

const Projects = () => {
  const {
    projects,
    loading,
    error,
    fetchRecentProjects,
    retryFetch,
    newCount,
    oldCount,
    usersMap,
  } = useFreelancerAPI();
  const { hasBidOn, addBidProjectId } = useMyBids();

  const navigate = useNavigate();

  useEffect(() => {
    const interval = setInterval(() => {
      if (!loading) fetchRecentProjects();
    }, 20000);
    return () => clearInterval(interval);
  }, [fetchRecentProjects, loading]);

  const handleRetry = async () => {
    try {
      await retryFetch();
    } catch (err) {
      console.error('Retry failed:', err.message);
    }
  };

  return (
    <div className="space-y-6">
      {/* Page Header */}
       <div className='flex items-center gap-3'>
            <button 
              onClick={() => navigate('/dashboard')}
              className="flex items-center justify-center"
            >
              <img src="/Icons/arrow-back.svg" alt="Back" className="w-8 h-8" />
            </button>
            <div>
              <h1 className="text-3xl font-bold text-gray-900 ">Recent Projects</h1>
            </div>
          </div>
      {/* Error Message */}
      {error && (
        <div className="bg-red-50 border border-red-200 text-red-700 p-4 rounded-lg mb-4">
          <strong>Error:</strong> {String(error)}
        </div>
      )}

      {/* Fetch Button */}
      <FetchButton
        onFetch={fetchRecentProjects}
        loading={loading}
        error={error}
        onRetry={handleRetry}
      />

      {/* Project List */}
      <ProjectList
        projects={projects}
        newCount={newCount}
        oldCount={oldCount}
        usersMap={usersMap}
        hasBidOn={hasBidOn}
        onBidPlaced={addBidProjectId}
      />
    </div>
  );
};

export default Projects;
